import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteMarcasVeiculo,
  findMarcasVeiculo,
  recordFiltering,
} from '~/store/modules/marcasveiculo/actions';

import Form from './form';

function MarcasVeiculoList() {
  const redux = useSelector((state) => state.marcasveiculo);

  const header = useMemo(
    () => [
      {
        id: 'codigoauxiliarmarcaveiculo',
        label: t('s.cadastro.marcasveiculo.codigoauxiliarmarcaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemarcaveiculo',
        label: t('s.cadastro.marcasveiculo.nomemarcaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'codigofipemarcaveiculo',
        label: t('s.cadastro.marcasveiculo.codigofipemarcaveiculo'),
        align: 'right',
        filter: { type: 'text' },
      },
    ],
    []
  );

  const fieldlist = [
    'codigoauxiliarmarcaveiculo',
    'nomemarcaveiculo',
    'codigofipemarcaveiculo',
  ];

  const substituirHeader = {
    codigoauxiliarmarcaveiculo: t(
      's.cadastro.marcasveiculo.codigoauxiliarmarcaveiculo'
    ),
    nomemarcaveiculo: t('s.cadastro.marcasveiculo.nomemarcaveiculo'),
    codigofipemarcaveiculo: t(
      's.cadastro.marcasveiculo.codigofipemarcaveiculo'
    ),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findMarcasVeiculo}
      remove={deleteMarcasVeiculo}
      form={Form}
      keys="idmarcaveiculo"
      detach="nomemarcaveiculo"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'marcasveiculos',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Marcas de Veiculo',
        })
      }
    />
  );
}

export default MarcasVeiculoList;
